import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { DeleteTransportActions } from "store/ducks/transports";

export function* deleteTransportRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(api.delete, `/transports/${id}`);

    const { data } = responseBody;
    yield put(DeleteTransportActions.success(data));
    notify("success", "Carga deletada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(DeleteTransportActions.failure(errorMessage));
  }
}
